export default {"src":"/_next/static/media/BlockChain.58cc34a9.svg","height":23,"width":30,"blurWidth":0,"blurHeight":0};